import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCapsules, faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import { MedicInformationContext } from "../../../../context/MedicInformationContextProvider";
import "./TimelineChart.css";

const TimeLineChart = () => {
  const [scrollData, setScrollData] = useState([]);
  const { afiliadoMedicamentos, afiliadoComorbilidades } = useContext(
    MedicInformationContext
  );

  useEffect(() => {
    const combinedData = [...afiliadoMedicamentos, ...afiliadoComorbilidades];

    const formattedData = combinedData.map((item, index) => {
      const marginTop =
        index % 3 === 0 ? "0px" : index % 3 === 1 ? "100px" : "20px"; // Controla el patrón de zigzag
      const content = item.medicamento ? (
        <>
          <div className="med-info">
            <FontAwesomeIcon icon={faCapsules} className="med-icon-timeline" />
            <div>
              <div>{item.medicamento}</div>
              <div className="med-date-timeline">{item.autorizacion}</div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="med-info">
            <FontAwesomeIcon
              icon={faHeartbeat}
              className="hearth-icon-timeline"
            />
            <div>
              <div>{item.descripcion}</div>
              <div className="med-date-timeline">{item.fecha}</div>
            </div>
          </div>
        </>
      );
      return (
        <div key={index} className="cell-timeline" style={{ marginTop }}>
          {content}
        </div>
      );
    });

    setScrollData(formattedData);
  }, [afiliadoMedicamentos, afiliadoComorbilidades]);

  return (
    <div className="table-container-timeline">
      <div className="table-row-timeline">
        {scrollData.length > 0 ? (
          scrollData.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))
        ) : (
          <div>Esperando datos...</div>
        )}
      </div>
    </div>
  );
};

export default TimeLineChart;
